import Url from "url-parse";

type URLUpdateParams = {
  href?: string;
  queryObject?: Record<string, unknown>;
  usePushState?: boolean;
};

export const urlUpdate = ({
  href = globalThis?.location?.href,
  queryObject,
  usePushState,
}: URLUpdateParams) => {
  const urlObject = new Url(href, true);
  urlObject.set("query", queryObject);

  if (globalThis?.history?.replaceState) {
    if (usePushState) {
      globalThis.history.pushState(queryObject, "", urlObject.href);
    } else {
      globalThis.history.replaceState(queryObject, "", urlObject.href);
    }
  }
};
